import { FC, Fragment, useMemo } from "react";
import { Stack, useTheme } from "@mui/material";
import { useParams } from "react-router-dom";

import { useAppSelector } from "@/store/hooks";
import { overviewTotalUtilization } from "@/store/commitments/selectors/overview/overviewTotalUtilizationSelector";
import { azureOverviewTotalUtilization } from "@/store/commitments/selectors/azure/overview/azureOverviewTotalUtilization";
import { ProviderType } from "@/services/cloudchipr.api";
import { CommitmentsOverviewCommitmentsMetadataCommitmentsCard } from "@/components/pages/commtiments/overview/content/components/cards/CommitmentsOverviewCommitmentsMetadataCommitmentsCard";
import { CommitmentsOverviewCommitmentsMetadataUtilizationCard } from "@/components/pages/commtiments/overview/content/components/cards/CommitmentsOverviewCommitmentsMetadataUtilizationCard";
import { AzureCommitmentsOverviewCommitmentsMetadataCommitmentsCard } from "@/components/pages/commtiments/azure/overview/cards/AzureCommitmentsOverviewCommitmentsMetadataCommitmentsCard";
import { AzureCommitmentsOverviewCommitmentsMetadataUtilizationCard } from "@/components/pages/commtiments/azure/overview/cards/AzureCommitmentsOverviewCommitmentsMetadataUtilizationCard";
import { HighchartsGaugeChart } from "@/storybook/c8r-highcharts/gauge-chart/HighchartsGaugeChart";

export const CommitmentsOverviewCommitmentsMetadata: FC = () => {
  const params = useParams();
  const provider = params?.provider as ProviderType;

  const awsTotalUtilization = useAppSelector(overviewTotalUtilization);
  const azureTotalUtilization = useAppSelector(azureOverviewTotalUtilization);

  const totalUtilization =
    provider === "azure" ? azureTotalUtilization : awsTotalUtilization;

  const { palette } = useTheme();

  const chartColors = useMemo(
    () => ({
      total: palette.grey[200],
      partial: palette.success.light,
    }),
    [palette],
  );

  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      gap={5}
      px={6}
      py={3}
    >
      <HighchartsGaugeChart
        value={totalUtilization ?? 0}
        colors={chartColors}
      />
      <Stack
        direction={{ xl: "row", xs: "column" }}
        gap={3}
        justifyContent="start"
      >
        {provider === "azure" ? (
          <Fragment>
            <AzureCommitmentsOverviewCommitmentsMetadataCommitmentsCard />
            <AzureCommitmentsOverviewCommitmentsMetadataUtilizationCard />
          </Fragment>
        ) : (
          <Fragment>
            <CommitmentsOverviewCommitmentsMetadataCommitmentsCard />
            <CommitmentsOverviewCommitmentsMetadataUtilizationCard />
          </Fragment>
        )}
      </Stack>
    </Stack>
  );
};
